import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { LayoutLegacy } from "@silvertours/front-legacy-entities";
import { contentBuilders } from "./content";
import { ColumnsModule, ContainerModule, ContentModule, ModuleType } from "./module";
var ContentModules = function(param) {
    var content = param.content;
    // @todo: validate unique keys
    var pageContent = content(contentBuilders);
    return /*#__PURE__*/ _jsx(LayoutLegacy.PlainSegment, {
        id: "content-modules",
        hasPadding: true,
        spacingScale: 4,
        children: /*#__PURE__*/ _jsx(LayoutLegacy.ContentContainer, {
            children: pageContent.map(function(part) {
                switch(part.type){
                    case ModuleType.Columns:
                        return /*#__PURE__*/ _jsx(ColumnsModule, _object_spread_props(_object_spread({}, part), {
                            id: part.key
                        }));
                    case ModuleType.Container:
                        return /*#__PURE__*/ _jsx(ContainerModule, _object_spread_props(_object_spread({}, part), {
                            id: part.key
                        }));
                    case ModuleType.ContentModule:
                        return /*#__PURE__*/ _jsx(ContentModule, _object_spread({}, part));
                    default:
                        return null;
                }
            })
        })
    });
};
export { ContentModules };
